const useRegaloStore = defineStore('regalo', () => {
  // state
  const regalo = ref({
    id             : null,
    compra_id      : null,
    mensaje        : '',
    abierto        : false,
    canjeado       : false,
    compra         : null,
    dador_id       : null,
    dador          : null,
    destinatario: null,
  });

  const regalos = ref([]);

  // mutations
  const setRegalo = (comp) => {
    if(comp) regalo.value = comp;
  };

  const setRegalos = (ps) => {
    if(ps) regalos.value = ps;
  }

  const clear = () => {
    regalo.value = {
      id: null,
      compra_id: null,
      mensaje: "",
      abierto: false,
      canjeado: false,
      compra: null,
      dador_id: null,
      dador: null,
      destinatario: null,
    };
  }

  // actions

  const fetch = (regalo_id) => {
    return new Promise((resolve,reject) => {
      axios.get(`/api/regalos/${regalo_id}/fetch-data`)
      .then(({data}) => {
        setRegalo(data);
        resolve(data);
      }).catch(e => reject(e));
    })
  }


  const regalar = (datos) => {
    return new Promise((resolve,reject) => {
      axios.post(`/api/regalos`,datos)
      .then(({data}) => {
        resolve(data);
      }).catch(e => reject(e));
    });
  };

  const abrir = async (token) => {
    try {
        const {data} = await axios.post(`/api/regalos/abrir`,{token});
        if(data.regalo && data.regalo.id){
          setRegalo(data.regalo);
        }
        return data;

    } catch (error) {
        throw error;
    }
  };


  const aplicar_beneficio = async (regalo_id)  => {
    try {
        const {data} = await axios.get(`/api/regalos/${regalo_id}/aplicar-beneficio`);
        return data;
    } catch (error) {
        throw error;
    }
  };

  const guardarMensaje = async (regalo_id,mensaje) => {
    try {
        const {data} = await axios.put(`/api/regalos/${regalo_id}/guardar-mensaje`,{mensaje});
        return data;
    } catch (error) {
        throw error;
    }
  };




  return {
    regalo,
    regalos,
    setRegalo,
    setRegalos,
    clear,
    fetch,
    regalar,
    abrir,
    aplicar_beneficio,
    guardarMensaje
  };

});

export default useRegaloStore;